import { cn } from "@/lib/utils";

const STATUS_CONFIG = {
  NOT_STARTED:  { label: "Not Started",  cls: "bg-[#FAFAFA]/80 text-[#706E6B] border border-[#C9C9C9]",  dot: "bg-slate-500" },
  IN_PROGRESS:  { label: "In Progress",  cls: "bg-sky-500/10 text-sky-400 border border-sky-500/30",     dot: "bg-sky-400 animate-pulse" },
  CONFIGURED:   { label: "Configured",   cls: "bg-indigo-500/10 text-indigo-400 border border-indigo-500/30", dot: "bg-indigo-400" },
  VALIDATED:    { label: "Validated",    cls: "bg-teal-500/10 text-[#2E844A] border border-teal-500/30",   dot: "bg-teal-400" },
  APPROVED:     { label: "Approved",     cls: "bg-amber-500/10 text-[#8C4B00] border border-amber-500/30", dot: "bg-amber-400" },
  ACTIVE:       { label: "Active",       cls: "bg-emerald-500/10 text-[#2E844A] border border-emerald-500/30", dot: "bg-emerald-400 shadow-[0_0_6px_rgba(16,185,129,0.5)]" },
  BLOCKED:      { label: "Blocked",      cls: "bg-rose-500/10 text-rose-400 border border-rose-500/30",   dot: "bg-rose-500 animate-ping" },
  SUPERSEDED:   { label: "Superseded",   cls: "bg-[#E5E5E5] text-[#706E6B] border border-[#C9C9C9]",   dot: "bg-slate-500" },
  ARCHIVED:     { label: "Archived",     cls: "bg-[#FAFAFA] text-[#706E6B] border border-[#C9C9C9]",   dot: "bg-[#E5E5E5]" },
  PLANNING:     { label: "Planning",     cls: "bg-sky-500/10 text-sky-400 border border-sky-500/30",      dot: "bg-sky-400" },
  ACTIVE_GEN:   { label: "Active",       cls: "bg-emerald-500/10 text-[#2E844A] border border-emerald-500/30", dot: "bg-emerald-400" },
};

export default function StatusBadge({ status, className, showDot = true, size = "sm" }) {
  const config = STATUS_CONFIG[status] || { label: status, cls: "bg-[#FAFAFA] text-[#706E6B] border border-[#C9C9C9]", dot: "bg-slate-500" };
  return (
    <span className={cn("inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md text-xs font-semibold font-mono tracking-wide", config.cls, className)}>
      {showDot && <span className={cn("w-1.5 h-1.5 rounded-full flex-shrink-0", config.dot)} />}
      {config.label}
    </span>
  );
}

export { STATUS_CONFIG };
